// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fT","advertDetailParameterList__header":"c-p_fU","advertDetailParameterList__list":"c-p_fV"};